import { useEffect, useState } from "react";
import api from "@/lib/api";

// Practice branding inside a client workspace: CSS custom properties on a wrapper element only — no utility classes, no inline colours in components.
export function useBranding(orgKey) {
  const [b, setB] = useState(null);
  useEffect(() => { let on = true; api.get("/branding/effective").then((r) => on && setB(r.data.branding)).catch(() => on && setB(null)); return () => { on = false; }; }, [orgKey]);
  return b;
}

export function brandStyle(b) {
  if (!b?.css) return undefined;
  return Object.fromEntries(Object.entries(b.css));
}

export function BrandMark({ b, dark = false, size = 24 }) {
  if (!b) return null;
  return (
    <div className="flex items-center gap-2 min-w-0 border-t-2 border-brand-raw pt-2" data-testid="practice-brand">
      {b.logo_url ? <img src={`${process.env.REACT_APP_BACKEND_URL}${b.logo_url}`} alt="" height={size} style={{ height: size, maxWidth: 120 }} className="object-contain rounded-sm" /> : null}
      <span className={`text-xs font-bold truncate ${dark ? "text-on-dark/80" : "text-subtle"}`}>Run by {b.display_name}</span>
    </div>
  );
}

export function PoweredBy({ dark = false }) {
  return <div className={`text-[10px] font-bold uppercase tracking-widest ${dark ? "text-on-dark/50" : "text-muted-foreground"}`} data-testid="powered-by-changeos">Powered by ChangeOS</div>;
}
